// extracted by mini-css-extract-plugin
export default {"bodyWpp":"WhatsAppWeb_bodyWpp__bS-m7","container":"WhatsAppWeb_container__4dRoG","icon":"WhatsAppWeb_icon__SmYIV"};